import {
    createSlice,
} from '@reduxjs/toolkit'

const initialState = {
    backdrop: false
}

const coreSlice = createSlice({
    name: 'core',
    initialState: initialState,
    reducers:{
        toggleBackdrop: (state, action) => {
            state.backdrop = !state.backdrop
        },
    }
})

export const { toggleBackdrop } = coreSlice.actions

export default coreSlice.reducer

